import { twResolve } from "@/helpers/tw-resolve";

export function CommentFieldInputBox({
  isSubmitting,
  isNote,
  disabled,
  children,
}: React.PropsWithChildren<{
  isSubmitting?: boolean;
  isNote?: boolean;
  disabled?: boolean;
}>): React.ReactElement {
  return (
    <div
      className={twResolve(
        "flex w-full flex-1 flex-col items-center gap-2 rounded-lg border border-grey-300 bg-white p-1 focus-within:border-grey-900 @4xl:flex-row @4xl:items-start",
        isSubmitting && "pointer-events-none opacity-30",
        // eslint-disable-next-line no-nested-ternary
        disabled ? "bg-grey-100" : isNote ? "bg-yellow-100" : "",
      )}
    >
      {children}
    </div>
  );
}
